import { useGetClaimsByOrderIdQuery } from "Order/Modules/Claim/Api/Query/getClaimsByOrderIdQuery";
import { isClaimDetailOpen } from "Order/Modules/Claim/Atom/claimDetailOpen";
import { AddNewClaim } from "Order/Modules/Claim/Components/AddNewClaim";
import { Close } from "@mui/icons-material";
import { Box, Drawer, Fab, Typography } from "@mui/material";
import { useAtom } from "jotai";
import { useParams } from "react-router";

export const ClaimDrawer = () => {
	const [isClaimOpen, setIsClaimOpen] = useAtom(isClaimDetailOpen);
	const { id: orderId } = useParams();
	const paramsOrderId = orderId ? Number(orderId) : undefined;
	const { data: claims = [] } = useGetClaimsByOrderIdQuery(paramsOrderId);

	return (
		<Drawer
			anchor="right"
			open={isClaimOpen}
			onClose={() => setIsClaimOpen(false)}
			PaperProps={{
				sx: {
					p: 2,
					width: {
						xs: "100%",
						sm: "85%",
						md: "75%",
						lg: "50%",
					},
				},
			}}
		>
			{claims.length === 0 ? (
				isClaimOpen && paramsOrderId && <AddNewClaim orderId={paramsOrderId} />
			) : (
				<Box
					sx={{
						p: 2,
						display: "flex",
						justifyContent: "space-between",
					}}
				>
					<Typography variant="h4">Cannot create more claims</Typography>
					<Fab size="small" onClick={() => setIsClaimOpen(false)}>
						<Close fontSize="small" />
					</Fab>
				</Box>
			)}
		</Drawer>
	);
};
